import { RouteComponentProps } from 'react-router-dom';
import { AddTask } from './add-task';

export function AddTaskHomeowner({
  history,
}: {
  history: RouteComponentProps['history'];
}) {
  return <AddTask history={history} isHomeowner />;
}
